import type { FaireProductEntity } from "../../entity_types/product";

export const p_zj65jt8t8h: FaireProductEntity = {
  token: "p_zj65jt8t8h",
  type: "product",
  name: "Soft Corduroy City Shorts (2S-2M-1L-1XL)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/f98489bd55f2ae1344f38d9da3c8c002594184568da6c51078dccfe383acec6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab227cd760cda8bde5b475a2bc5358742c529da3321bcd946de683cfa0cecb15.jpeg",
    "https://cdn.faire.com/fastly/4cac5c727244a02a51fc09dcdd56a9be95f5cd1aa57e061013c82dc628b9728d.jpeg",
    "https://cdn.faire.com/fastly/998cc8b04818d4510f328f88020968f36384776c7bd98ce6a88ab21fad8f4da1.jpeg",
    "https://cdn.faire.com/fastly/e06a17cccab8ef1fb9f866e17b074347ee86540dd5e825dcef4bc3bf687f4ba4.jpeg",
    "https://cdn.faire.com/fastly/78acf494f486babb439d7d08118ce1e805cb03bc89f753106681c7ed866817f0.jpeg",
    "https://cdn.faire.com/fastly/2653afb4e938a831b71b8899e47fc5551d67766391db061aa790f756cb488b71.jpeg",
  ],
  priceDollars: 324,
  description:
    'Why We Made This?\n\nA little structure, a little softness. The Soft Corduroy City Shorts inherit design details from our City Shorts and Soft Corduroy Arc Pants, featuring subtle flare panels for a flattering A-line fit. Finished with a high-waisted elastic waistband and side pockets, they’re made for styling with fun socks and statement shoes.\n\n\n𝗣𝗹𝗲𝗮𝘀𝗲 𝗻𝗼𝘁𝗲:\n\nThe dyeing and washing process gives each garment unique character. Please allow for slight color and fit variation for each garment as is the beauty of garment dye and wash. Pieces with the same color name may not match exactly.\n\n\n𝗖𝗼𝗻𝘁𝗲𝗻𝘁𝘀:\n\n100% Cotton\n\n\n𝗖𝗮𝗿𝗲 𝗜𝗻𝘀𝘁𝗿𝘂𝗰𝘁𝗶𝗼𝗻𝘀:\n\n• Washing these garments only with like colors and in cold water\n\n• Recommend to Hang Dry for the best result!\n\n\n𝗔𝗽𝗽𝗿𝗼𝘅𝗶𝗺𝗮𝘁𝗲 𝗠𝗲𝗮𝘀𝘂𝗿𝗲𝗺𝗲𝗻𝘁𝘀:\n\nSmall: Waist 12” relaxed, Hip 22", Inseam 5", Leg opening 13”, Rise 10 1/2"\n\nMedium: Waist 13” relaxed, Hip 23", Inseam 5 1/4”, Leg opening 13 1/2", Rise 10 3/4"\n\nLarge: Waist 14” relaxed, Hip 24", Inseam 5 1/2”, Leg opening 14", Rise 11"\n\nX-Large: Waist 15” relaxed, Hip 25", Inseam 5 3/4”, Leg opening 14 1/2", Rise 11 1/4"\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size small\n\n\nMade in South Korea\n\n\nMSRP: $110 USD',
  tags: [],
  msrpDollars: 648,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:10.675Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
